<template>
    <div>
      <p class="ArticleNormal">
        2020年，是抖音用户@睿智先生 创业的第7年。
      </p>
      <p class="ArticleNormal">
        三年前，他在武汉光谷资本大厦敲下青创板上市的钟声。作为土生土长的武汉人，他眼中的光谷是一个筑梦之城。“它不一定让每个人梦想成真，却提供了无数个造梦的机会”。
      </p>
      <p class="ArticleNormal">
        他说，创业初期，没人比他更懂武汉冬天凌晨4点的寒冷。但拿到市政府12万创业补贴时，他觉得一切都是值得的。@睿智先生 其实是无数光谷人的缩影。现如今的武汉光谷，有成千上万和他一样的筑梦者。
      </p>
      <video src="../../../assets/1st/Articles/Article_7/video_1.mp4" controls poster="../../../assets/1st/Articles/Article_7/poster_1.jpg"></video>
      <p class="ArticleNormal">
        “惟楚有才”，湖北武汉向来是人才的“发源地”，“百万学子”的名片也广为人知。而坐拥“40多个高等院校，50多个科研所，80多万大学生和20多万的专业技术人员”的光谷，却一度鲜为外地人所知。
      </p>
      <p class="ArticleNormal">
        “如何向外界证明这是一个宜居宜业之地，以推动光谷招财引智、吸引更多人才”，一度成为光谷的命题“作文”。
      </p>
      <p class="ArticleNormal">
        人潮涌动，而属于光谷的“年轻人”在哪儿？光谷的目光，向短视频望去。
      </p>
      <p class="ArticleHead">
        借力短视频，巧设筑梦之城“人设”
      </p>
      <p class="ArticleNormal">
        聚焦短视频并非心血来潮。选择背后，是光谷基于自身痛点做出的战略决策。
      </p>
      <p class="ArticleNormal">
        一方面，知名度是“招才引智”的底气，要想“引凤还巢”光谷需要在全国范围内提升知名度；另一方面，要保持年轻力，吸引更多年轻人则是题中之义。在这个背景下，拥有海量年轻用户和顶级曝光渠道的抖音成为了合作的首选。
      </p>
      <p class="ArticleNormal">
        而放眼抖音，城市们“争奇斗艳”，要想突围而出，必须找准定位。细数抖音曾“带红”的多个城市，武汉“樱花之城”，重庆“魔幻之都”，西安“梦回长安”……显然，个性鲜明的“城设”，才能吸引年轻人真正关注光谷，实现“出圈”。
      </p>
      <p class="ArticleNormal">
        回看光谷，这里高校林立人才济济，每天都有一百多家高新企业诞生，优秀人才聚集，而地标“马蹄莲”惊艳绽放，彰显着这里的科技与潮流……正如巨量引擎项目负责人王飞所说，“光谷不仅是一个地名，更是全国人才追梦、筑梦、圆梦的梦想大本营。”它所代表的科技、梦想和希望，是光谷身上最大的“标签”。
      </p>
      <p class="ArticleNormal">
        在巨量引擎与光谷双方几轮沟通后，“筑梦之城”的“城设”诞生。
      </p>
      <p class="ArticleHead">
        线上筑梦，光谷的华丽绽放
      </p>
      <p class="ArticleNormal">
        但找到“城设”只是起点，想要人们真正接受这一“城设”，就必须精准洞察用户痛点、量体裁衣，用大众喜闻乐见的形式进行沟通，系统化输出城市名片。
      </p>
      <p class="ArticleNormal">
        围绕“筑梦之城”，巨量引擎和光谷开启了一场长线名片打造计划。
      </p>
      <p class="ArticleNormal">
        如何撩动年轻人？直击北漂、沪漂等游子的痛点，光谷在抖音上发起#我是光谷追梦人 的话题，以年轻人的视角回望家乡，用鲜活的故事细数光谷的好。
      </p>
      <p class="ArticleNormal">
        “在这里你可以拿着接近北上广深的工资，享受着只有一线城市一半的物价。”“光谷正在大量地吸引互联网公司……创新创业的氛围给予我们很大的信心。”联动高新区政府、园区企业、本地就业人群、武汉本地KOL，光谷打造《我是光谷追梦人》系列访谈短视频。访谈中，北漂三年的武汉女孩，在光谷创业再出发的退伍军人，入驻光谷的名企高管……以光谷人看光谷，多视角讲述和光谷的故事，持续激发着各地异地就业人才的情感共鸣，用深度情感沟通，让更多“荆楚之才”回乡筑梦。
      </p>
      <div>
        <img class="Img2" src="../../../assets/1st/Articles/Article_7/contant_1.jpg"/>
        <img class="Img2" src="../../../assets/1st/Articles/Article_7/contant_2.jpg"/>
      </div>
      <p class="ArticleNormal">
        情感沟通后，“乘胜追击”成为重点，以诱人的人才引进政策吸引更多异地人才落地光谷。如何有效输出“光谷政策”？懂年轻人的光谷突破传统的宣讲模式，创造性地选择巨量引擎的重磅IP“头号英雄”来传播自家的人才政策。
      </p>
      <p class="ArticleNormal">
        从“中国光谷有几大园区”、“光谷聚集了多少五百强企业？”，到“光谷启动的引才计划包括哪些”，通过知识答题这种趣味化的方式，光谷将原本枯燥的人才新政转化为“瓜分50万奖金”的闯关大战，架起了与年轻人才沟通的桥梁。
      </p>
      <img src="../../../assets/1st/Articles/Article_7/contant_3.png"/>
      <p class="ArticleNormal">
        作为一座科技新城，光谷和《头号英雄》的结合，真正做到了知识的强强联合。在直播答题的强互动、强激励下，最终，活动参与人数达到79.1万，在趣味输出光谷城市政策的同时，也让更多中高端人才知道光谷、了解光谷，传递了光谷“高速发展，求贤若渴”的城市标签。
      </p>
      <p class="ArticleNormal">
        此外，为了更好地和年轻人“玩”在一起，光谷还联动抖音年度重点IP抖in City城市美好生活节，坐镇湖北城市馆，向全国人才发出邀请。酷炫的地标场景设计、趣味体验设施配合达人互动，光谷馆“打卡”人数超过3万，展现了充满科技感和创新性的光谷风采，也打破了光谷“地处偏僻、出行不便、生活单调、总是加班”的刻板印象。
      </p>
      <p class="ArticleNormal">
        而在2020年“抖in武汉乐来越好”城市云端live秀上，光谷更是代表武汉率先发声，向全国传递“英雄归来”。整个活动覆盖超1亿用户，相关话题播放量高达7000万+，为光谷带来海量曝光。以充满潮流气息的标志性建筑“马蹄莲”为背景，光谷再一次刷新了“科技之城”的城市形象。
      </p>
      <p class="ArticleNormal">
        从以逐梦故事引发情感共鸣，到携手《头号英雄》趣味输出自家人才政策，发起“在线人才邀约”，再到用强互动的打卡、城市秀与年轻人玩到一起，一波“操作”后，“中国光谷”累计曝光超10亿，官方抖音号涨粉13万，光谷成功将“梦想大本营”的“城设”植入年轻人的心里，打破刻板印象，全面焕新城市形象。
      </p>
      <p class="ArticleHead">
        未来路径：城市整合营销的新可能
      </p>
      <p class="ArticleNormal">
        着力抖音、明确“城设”、“趣撩”年轻人，在巨量引擎湖北分公司总经理张威看来，“筑梦光谷”已成为通过短视频整合营销打造城市名片的经典案例。而正所谓“他山之石可以攻玉”，其间的城市营销方法论可供参考。
      </p>
      <p class="ArticleNormal">
        “爆款”之城，一定是年轻人之城。了解年轻人的喜好，用潮流的方式互动，是光谷“出圈”的关键。对此，张威表示，新时代的城市营销要建立年轻人青睐的短视频思维，“用对话代替宣传，故事趣味代替信息输出，演绎代替复述。”例如中国光谷V-LOG共创大会，就是通过短视频打造更受年轻人喜爱的区域宣传片，使得“光谷打卡”在抖音流行。
      </p>
      <img src="../../../assets/1st/Articles/Article_7/contant_4.jpg"/>
      <p class="ArticleNormal">
        打造“超级符号”，才能“超级”出圈。注意力经济时代，鲜明的形象才是“攻心”的利器。在这方面，抖音总结了城市推广中必不可少的四大元素“BEST”，即BGM-城市音乐、Eating-本地饮食、Scenery-景观景色、Technology-科技感的设施，以组成城市的超级符号，让“城设”深入人心。
      </p>
      <p class="ArticleNormal">
        优质营销IP会让城市营销事半功倍。在张威看来，传播性强、互动性高的城市级IP活动，有利于多维度输出城市故事，提升城市声量。而抖音不仅拥有抖in City城市美好生活节、巨量中国等优质城市营销IP，还具备强大的资源整合能力，堪称城市营销的“黄金助攻”。
      </p>
      <p class="ArticleNormal">
        短视频改变了城市营销的方式，也为其带来了源源不断的活力。对于光谷来说，与抖音合作的未来值得更多期待。
      </p>
      <p class="ArticleNormal">
        “中国每个城市都不缺乏好故事，但我们缺乏讲好故事的形式和方式。”张威表示，“当然，这也是我们平台为之努力发挥价值的方向之一：努力通过民众喜闻乐见的方式去讲好城市故事，讲好中国故事。”
      </p>
      <p class="ArticleNormal">
        光谷是追梦人的归宿，也是追梦人开始做梦的地方。光谷如今的成就，源于一代代年轻人的奋斗，也是光谷善于拥抱变化的成果。
      </p>
      <p class="ArticleNormal">
        夜幕星河，华灯初上，光谷写字楼的灯也亮了起来。
      </p>
    </div>
</template>

<script>
    export default {
        name: "Article7"
    }
</script>

<style scoped>
  img{
    width: 100%;
  }
  video{
    width: 100%;
  }
  .Img2{
    width: 50%;
    display: block;
    float: left;
    margin-bottom: 3rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/1st/Articles/Article7.vue